(function () {
  'use strict';

  var clock = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  var dateLabel = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'UTC', day: 'numeric', month: 'long'
  });

  function isPublicOpening(status) {
    return status === 'open' || status === 'holiday' || status === 'no-meal';
  }

  function message(now) {
    var calendar = window.SJVSeasonCalendar;
    if (!calendar || !calendar.opening) return { text: 'Consultez le calendrier', open: false };
    var parts = {};
    clock.formatToParts(now).forEach(function (part) { parts[part.type] = part.value; });
    var key = parts.year + '-' + parts.month + '-' + parts.day;
    var minutes = +parts.hour * 60 + +parts.minute;
    var status = calendar.opening[key];
    var openDates = Object.keys(calendar.opening).filter(function (date) {
      return isPublicOpening(calendar.opening[date]);
    }).sort();
    if (!openDates.length) return { text: 'Consultez le calendrier', open: false };
    var first = openDates[0], last = openDates[openDates.length - 1];

    function nextOpening() {
      var next = openDates.find(function (date) { return date > key; });
      if (!next) return { text: 'Fermé · Hors saison', open: false };
      var tomorrow = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day + 1));
      if (next === tomorrow.toISOString().slice(0, 10)) {
        return { text: 'Fermé · Ouvre demain à 10h', open: false };
      }
      return { text: 'Fermé · Ouvre le ' + dateLabel.format(new Date(next + 'T00:00:00Z')) + ' à 10h', open: false };
    }

    if (key < first) return nextOpening();
    if (+parts.year > calendar.year) return { text: 'Calendrier à venir', open: false };
    if (key > last) return { text: 'Fermé · Hors saison', open: false };
    if (status === 'school') return { text: 'Fermé au public · Journée scolaire', open: false };
    if (!isPublicOpening(status)) return { text: 'Fermé aujourd’hui', open: false };
    if (minutes < 600) return { text: 'Fermé · Ouvre à 10h', open: false };
    if (minutes < 1080) return { text: 'Ouvert · Ferme à 18h', open: true };
    return nextOpening();
  }

  function refresh() {
    var result = message(new Date());
    document.querySelectorAll('[data-sjv-opening-status]').forEach(function (element) {
      var text = element.querySelector('[data-sjv-opening-status-text]');
      if (!text) return;
      if (text.textContent !== result.text) text.textContent = result.text;
      element.classList.toggle('is-open', result.open);
      element.hidden = false;
    });
  }

  refresh();
  window.setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
